import React from 'react';
import { t } from '@lingui/macro';

import ErrorMessage from './ErrorMessage';

const SearchError = (): JSX.Element => {
  return (
    <ErrorMessage
      title={t`Whoops! We couldn't perform your search.`}
      subtitle={t`Make sure the information you entered is correct and try again.`}
    />
  );
};

export default SearchError;
